




























import { namespace } from 'vuex-class';
import { Vue, Component, Watch } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

import Input from '@/shared/components/Inputs/Input.vue';
import Field from '@/shared/components/Field/Field.vue';
import Select from '@/shared/components/Inputs/Select.vue';

import { ICheckoutCartOfferPrice } from '@/interfaces/Checkout';

const CheckoutModule = namespace('App/Checkout');

@Component({
  components: {
    Input,
    Field,
    Select,
    ValidationObserver,
    ValidationProvider,
  }
})
export default class EmpiricusRewardsForm extends Vue {
  public $refs!: {
    observer: any,
  };

  private value: number|null = null;

  @CheckoutModule.Getter
  private selectedOffer!: any;

  @CheckoutModule.Getter
  private selectedOfferPrice!: ICheckoutCartOfferPrice;

  @CheckoutModule.Action
  private selectOfferPaymentStructure!: (priceId: number)=> void;

  private get offerPrices () {
    return this.selectedOffer.offer_price;
  }

  mounted () {
    this.value = this.selectedOfferPrice.id;
  }
}
